module.exports = __webpack_public_path__ + "img/img20.df8baad8.svg";